export const manhwaComics = [
  {
    id: 1,
    title: '我独自升级',
    titleEn: 'Solo Leveling',
    author: 'Chugong / 张成乐',
    artist: 'DUBU（REDICE STUDIO）',
    status: '已完结',
    rating: 9.7,
    category: '热血战斗',
    tags: ['奇幻', '战斗', '升级流', '逆袭'],
    description: '十年前，世界各地出现了连接异次元的"门"，同时也出现了觉醒特殊能力的"猎人"。身为E级猎人的成振宇，在一次地下城探险中遭遇生死危机后，意外获得了能够无限升级的"系统"。从此踏上从最弱到最强的逆袭之路。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20Solo%20Leveling%20style%2C%20dark%20fantasy%20hunter%20with%20glowing%20eyes%2C%20epic%20battle%20scene%2C%20clean%20illustration%20style%2C%20vibrant%20dark%20red%20and%20black%20tones%2C%20professional%20webtoon%20cover%20design%20with%20centered%20character%20portrait%20on%20dark%20gradient%20background&width=400&height=560&seq=manhwa-cover-01&orientation=portrait',
    chapters: 179,
    updateDate: '2024-12-20',
    featured: true,
    hot: true,
    newRelease: false,
    slug: 'solo-leveling'
  },
  {
    id: 2,
    title: '神之塔',
    titleEn: 'Tower of God',
    author: 'SIU',
    artist: 'SIU',
    status: '连载中',
    rating: 9.5,
    category: '奇幻冒险',
    tags: ['奇幻', '冒险', '友情', '世界观宏大'],
    description: '少年"夜"为了追寻唯一的朋友"蕾哈尔"，进入了充满谜团的神之塔。每层塔都有不同的试炼，只有通过试炼才能向上攀升。在攀登的过程中，夜结识了许多伙伴，也发现了关于塔和自身的惊人秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Tower%20of%20God%20style%20manhwa%20cover%2C%20mysterious%20young%20boy%20climbing%20a%20towering%20structure%2C%20watercolor%20and%20ink%20style%20illustration%2C%20ethereal%20blue%20and%20gold%20color%20palette%2C%20fantasy%20adventure%20webtoon%20cover%20design%20with%20dramatic%20lighting&width=400&height=560&seq=manhwa-cover-02&orientation=portrait',
    chapters: 620,
    updateDate: '2025-01-15',
    featured: true,
    hot: true,
    newRelease: false,
    slug: 'tower-of-god'
  },
  {
    id: 3,
    title: '女神降临',
    titleEn: 'True Beauty',
    author: 'Yaongyi',
    artist: 'Yaongyi',
    status: '已完结',
    rating: 9.3,
    category: '恋爱校园',
    tags: ['恋爱', '校园', '化妆', '成长'],
    description: '因为外貌自卑的女高中生任朱静，通过化妆技巧焕然一新，成为了校园女神。在新的学校里，她遇到了两个截然不同的男生——高冷学霸李修浩和阳光校草韩书俊。一场关于外貌、自卑与真爱的成长故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=True%20Beauty%20style%20Korean%20romance%20manhwa%20cover%2C%20beautiful%20girl%20with%20makeup%20and%20flowers%2C%20soft%20pink%20and%20peach%20pastel%20tones%2C%20shojo%20style%20illustration%2C%20romantic%20high%20school%20webtoon%20cover%20design%20with%20sparkle%20effects&width=400&height=560&seq=manhwa-cover-03&orientation=portrait',
    chapters: 253,
    updateDate: '2024-08-01',
    featured: false,
    hot: true,
    newRelease: false,
    slug: 'true-beauty'
  },
  {
    id: 4,
    title: '全知读者视角',
    titleEn: 'Omniscient Reader\'s Viewpoint',
    author: 'sing N song',
    artist: 'Sleepy-C',
    status: '连载中',
    rating: 9.6,
    category: '奇幻冒险',
    tags: ['奇幻', '末世', '系统流', '生存'],
    description: '金独子是一个普通的上班族，唯一的热爱是阅读网络小说《在灭亡的世界中生存的三种方法》。当小说中的末日场景突然降临现实时，作为唯一读完这部小说的人，他成为了唯一知晓世界走向的存在。',
    coverImage: 'https://readdy.ai/api/search-image?query=Omniscient%20Reader%20Viewpoint%20style%20Korean%20manhwa%20cover%2C%20apocalyptic%20fantasy%20scene%20with%20constellations%2C%20man%20in%20black%20coat%20standing%20among%20ruins%2C%20deep%20navy%20and%20gold%20color%20scheme%2C%20dramatic%20webtoon%20cover%20design%20with%20celestial%20elements&width=400&height=560&seq=manhwa-cover-04&orientation=portrait',
    chapters: 210,
    updateDate: '2025-01-10',
    featured: true,
    hot: true,
    newRelease: false,
    slug: 'omniscient-reader'
  },
  {
    id: 5,
    title: '剑尊归来',
    titleEn: 'Return of the Mount Hua Sect',
    author: 'Biga / LICO',
    artist: 'LICO',
    status: '连载中',
    rating: 9.4,
    category: '武侠仙侠',
    tags: ['武侠', '重生', '宗门', '搞笑'],
    description: '华山派曾经的传奇剑尊——青冥，在与魔教教主的大战后陨落。百年后，他重生为华山派最底层的少年弟子。面对凋零的华山派和武林乱局，他以百年前的绝世剑法重新崛起，拯救师门。',
    coverImage: 'https://readdy.ai/api/search-image?query=Return%20of%20Mount%20Hua%20Sect%20style%20Korean%20manhwa%20cover%2C%20martial%20arts%20swordsman%20in%20traditional%20robes%2C%20plum%20blossoms%20and%20mountains%2C%20ink%20wash%20painting%20style%20with%20pink%20and%20green%20accents%2C%20wuxia%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-05&orientation=portrait',
    chapters: 178,
    updateDate: '2025-01-18',
    featured: true,
    hot: false,
    newRelease: true,
    slug: 'return-mount-hua'
  },
  {
    id: 6,
    title: '某天成为公主',
    titleEn: 'Who Made Me a Princess',
    author: 'Plutus / Spoon',
    artist: 'Spoon',
    status: '已完结',
    rating: 9.5,
    category: '恋爱宫廷',
    tags: ['穿越', '宫廷', '父女', '奇幻'],
    description: '现代女孩穿越成为小说中注定被父皇处死的公主阿塔娜西亚。为了改变命运，她从小就努力讨好冷酷的皇帝父亲。然而随着时间推移，她发现这个世界的真相远比小说中描述的复杂得多。',
    coverImage: 'https://readdy.ai/api/search-image?query=Who%20Made%20Me%20a%20Princess%20style%20manhwa%20cover%2C%20elegant%20princess%20with%20golden%20hair%20and%20fancy%20dress%2C%20palace%20background%20with%20roses%2C%20soft%20pastel%20pink%20and%20gold%20color%20scheme%2C%20romantic%20fantasy%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-06&orientation=portrait',
    chapters: 125,
    updateDate: '2024-06-15',
    featured: false,
    hot: true,
    newRelease: false,
    slug: 'who-made-me-princess'
  },
  {
    id: 7,
    title: '反派千金的执事',
    titleEn: 'The Villainess\'s Butler',
    author: 'Jaeunhyang / Han Mint',
    artist: 'Han Mint',
    status: '连载中',
    rating: 9.2,
    category: '恋爱宫廷',
    tags: ['重生', '宫廷', '逆袭', '浪漫'],
    description: '死后重生为小说中反派千金的专属执事，他决定利用前世的记忆帮助小姐免于悲惨结局。在贵族社会的阴谋与斗争中，两人之间的关系也逐渐超越了主仆之情。',
    coverImage: 'https://readdy.ai/api/search-image?query=Villainess%20butler%20style%20Korean%20manhwa%20cover%2C%20handsome%20butler%20in%20black%20suit%20beside%20elegant%20noble%20lady%2C%20Victorian%20palace%20background%2C%20dark%20romance%20style%20with%20red%20and%20black%20tones%2C%20otome%20isekai%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-07&orientation=portrait',
    chapters: 98,
    updateDate: '2025-01-20',
    featured: false,
    hot: false,
    newRelease: true,
    slug: 'villainess-butler'
  },
  {
    id: 8,
    title: '我培育的S级',
    titleEn: 'My S-Class Hunters',
    author: 'Geunseo / Biwan',
    artist: 'Biwan',
    status: '连载中',
    rating: 9.1,
    category: '热血战斗',
    tags: ['奇幻', '战斗', '猎人', '养成'],
    description: '在猎人与地下城并存的世界里，F级猎人韩宥真意外获得了一项特殊能力——培养其他猎人的能力等级。他开始培养那些被埋没的人才，组建最强的猎人团队。',
    coverImage: 'https://readdy.ai/api/search-image?query=My%20S%20Class%20Hunters%20style%20Korean%20manhwa%20cover%2C%20dungeon%20hunter%20team%20posing%20with%20weapons%2C%20fantasy%20action%20scene%2C%20vibrant%20orange%20and%20teal%20color%20scheme%2C%20dynamic%20webtoon%20cover%20design%20with%20energy%20effects&width=400&height=560&seq=manhwa-cover-08&orientation=portrait',
    chapters: 156,
    updateDate: '2025-01-12',
    featured: false,
    hot: false,
    newRelease: true,
    slug: 'my-s-class-hunters'
  },
  {
    id: 9,
    title: '伯爵家的废物',
    titleEn: 'Lout of Count\'s Family',
    author: 'Yu Ryeo Han / PAN4',
    artist: 'PAN4',
    status: '连载中',
    rating: 9.3,
    category: '奇幻冒险',
    tags: ['穿越', '奇幻', '家族', '策略'],
    description: '现代人金禄秀穿越成为小说中注定早死的反派配角——伯爵家的废物儿子凯尔。为了在这个危险的世界生存下去，他决定低调行事，但命运的车轮却总是将他推向风暴中心。',
    coverImage: 'https://readdy.ai/api/search-image?query=Lout%20of%20Count%20Family%20Korean%20manhwa%20cover%2C%20red%20haired%20noble%20young%20man%20in%20medieval%20fantasy%20setting%2C%20castle%20background%20with%20dragons%2C%20warm%20red%20and%20gold%20color%20palette%2C%20isekai%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-09&orientation=portrait',
    chapters: 134,
    updateDate: '2025-01-08',
    featured: false,
    hot: true,
    newRelease: false,
    slug: 'lout-of-count-family'
  },
  {
    id: 10,
    title: '拯救反派',
    titleEn: 'Villains Are Destined to Die',
    author: 'Gwon Gyeoeul / SUOL',
    artist: 'SUOL',
    status: '连载中',
    rating: 9.4,
    category: '恋爱宫廷',
    tags: ['穿越', '游戏', '反派', '恋爱'],
    description: '穿越成为乙女游戏中的反派千金佩内洛普，所有路线都会导致她的死亡。为了活下来，她必须攻略游戏中那些危险的反派角色。但每个选择都伴随着致命的后果。',
    coverImage: 'https://readdy.ai/api/search-image?query=Villains%20Are%20Destined%20to%20Die%20style%20manhwa%20cover%2C%20beautiful%20villainess%20with%20purple%20hair%20holding%20a%20rose%2C%20dark%20gothic%20palace%20interior%2C%20dramatic%20purple%20and%20black%20color%20scheme%2C%20otome%20game%20isekai%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-10&orientation=portrait',
    chapters: 167,
    updateDate: '2025-01-14',
    featured: true,
    hot: true,
    newRelease: false,
    slug: 'villains-destined-to-die'
  },
  {
    id: 11,
    title: '反派的美男计',
    titleEn: 'The Villainess Turns the Hourglass',
    author: 'Sanasobee / Antstudio',
    artist: 'Antstudio',
    status: '已完结',
    rating: 9.3,
    category: '恋爱宫廷',
    tags: ['重生', '复仇', '宫廷', '逆袭'],
    description: '贵族千金阿莉亚被继妹陷害致死，却因神秘沙漏之力重生回到过去。这一次，她决定不再做任人欺凌的弱者。利用前世记忆，她步步为营展开复仇，让曾经伤害她的人付出代价。',
    coverImage: 'https://readdy.ai/api/search-image?query=The%20Villainess%20Turns%20the%20Hourglass%20style%20manhwa%20cover%2C%20elegant%20blonde%20noblewoman%20holding%20a%20golden%20hourglass%2C%20luxurious%20Victorian%20ballroom%2C%20gold%20and%20cream%20color%20palette%2C%20revenge%20isekai%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-11&orientation=portrait',
    chapters: 100,
    updateDate: '2024-09-30',
    featured: false,
    hot: false,
    newRelease: false,
    slug: 'villainess-hourglass'
  },
  {
    id: 12,
    title: '再婚皇后',
    titleEn: 'The Remarried Empress',
    author: 'Alphatart / Sumpul',
    artist: 'Sumpul',
    status: '连载中',
    rating: 9.2,
    category: '恋爱宫廷',
    tags: ['宫廷', '离婚', '再婚', '女强'],
    description: '东大帝国皇后纳维耶，在皇帝丈夫公开纳妾并提出离婚后，毅然选择接受。她同意与邻国国王再婚，奔赴新的国度开启新的人生篇章。一个关于成长、独立与重新寻找爱情的故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Remarried%20Empress%20Korean%20manhwa%20cover%2C%20majestic%20empress%20in%20elaborate%20golden%20crown%20and%20gown%2C%20imperial%20palace%20throne%20room%2C%20royal%20blue%20and%20gold%20color%20scheme%2C%20historical%20romance%20fantasy%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-12&orientation=portrait',
    chapters: 145,
    updateDate: '2025-01-17',
    featured: false,
    hot: false,
    newRelease: true,
    slug: 'remarried-empress'
  }
];

export const categories = [
  { id: 1, name: '热血战斗', slug: 'hot-blooded-battle', description: '热血激燃的战斗场面，主角一步步变强的成长故事', icon: 'ri-sword-line', count: 125 },
  { id: 2, name: '恋爱校园', slug: 'romance-school', description: '甜蜜的校园恋爱故事，青春的美好与悸动', icon: 'ri-heart-line', count: 89 },
  { id: 3, name: '奇幻冒险', slug: 'fantasy-adventure', description: '穿越异世界，探索未知大陆的奇幻冒险之旅', icon: 'ri-compass-3-line', count: 156 },
  { id: 4, name: '恋爱宫廷', slug: 'romance-palace', description: '华丽的宫廷背景下，动人的爱情与权谋故事', icon: 'ri-vip-crown-line', count: 72 },
  { id: 5, name: '武侠仙侠', slug: 'martial-arts', description: '江湖恩仇、修炼飞升，东方玄幻的精彩世界', icon: 'ri-magic-line', count: 64 },
  { id: 6, name: '悬疑惊悚', slug: 'suspense-thriller', description: '紧张刺激的悬疑故事，烧脑推理与心理博弈', icon: 'ri-search-eye-line', count: 38 }
];

export const latestUpdates = [
  { id: 1, comicId: 2, chapterTitle: '第620话 - 塔顶的真相', updateTime: '2小时前', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20chapter%20thumbnail%2C%20mysterious%20tower%20top%20scene%2C%20dark%20fantasy%20illustration%2C%20small%20thumbnail%20format&width=120&height=160&seq=update-cover-01&orientation=portrait' },
  { id: 2, comicId: 5, chapterTitle: '第178话 - 华山论剑', updateTime: '3小时前', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20chapter%20thumbnail%2C%20martial%20arts%20tournament%20scene%2C%20wuxia%20illustration%2C%20small%20thumbnail%20format&width=120&height=160&seq=update-cover-02&orientation=portrait' },
  { id: 3, comicId: 4, chapterTitle: '第210话 - 星座的意志', updateTime: '5小时前', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20chapter%20thumbnail%2C%20constellation%20fantasy%20scene%2C%20dramatic%20night%20sky%20illustration%2C%20small%20thumbnail%20format&width=120&height=160&seq=update-cover-03&orientation=portrait' },
  { id: 4, comicId: 7, chapterTitle: '第98话 - 午夜的约定', updateTime: '6小时前', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20chapter%20thumbnail%2C%20romantic%20night%20scene%20with%20couple%2C%20soft%20dark%20illustration%2C%20small%20thumbnail%20format&width=120&height=160&seq=update-cover-04&orientation=portrait' },
  { id: 5, comicId: 8, chapterTitle: '第156话 - S级觉醒', updateTime: '8小时前', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20chapter%20thumbnail%2C%20hunter%20awakening%20scene%20with%20energy%2C%20action%20illustration%2C%20small%20thumbnail%20format&width=120&height=160&seq=update-cover-05&orientation=portrait' },
  { id: 6, comicId: 12, chapterTitle: '第145话 - 新皇登基', updateTime: '10小时前', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20chapter%20thumbnail%2C%20royal%20coronation%20ceremony%20scene%2C%20historical%20fantasy%20illustration%2C%20small%20thumbnail%20format&width=120&height=160&seq=update-cover-06&orientation=portrait' }
];

export const manhwaSections = {
  hot: manhwaComics.filter(m => m.hot),
  newRelease: manhwaComics.filter(m => m.newRelease),
  featured: manhwaComics.filter(m => m.featured),
  completed: manhwaComics.filter(m => m.status === '已完结'),
  ongoing: manhwaComics.filter(m => m.status === '连载中')
};